import * as React from "react";
import DropTablesNav from "./DropTablesNav";
import AdLayout from "../../app-core/AdLayout";
import LootGrid from "../LootGrid";
import * as T from "common/src/bindings/Translation2";

type Tables = Array<{
  loss: number;
  // breakpoint: number;
  // value: number;
  options: Array<[number, Array<any>]>;
}>;

export default function FortuneTables({ tables }: { tables: Tables }) {
  return (
    <AdLayout>
      <div className="flex flex-col bg-bg rounded w-full md:w-[928px] pb-4">
        <DropTablesNav route={"Fortune"} />
        <h2 className="h2 p-4 pb-0 flex items-center gap-1">
          {T.common("Fortune Rewards")}
        </h2>
        {tables.map(({ loss, options }) => {
          return (
            <>
              <h3 className="self-start pt-10 ml-3 px-1 pb-[2px] mb-3 h3 leading-tight border-b border-primary-11">
                {T.common("# Loss").replace("#", String(loss))}
              </h3>
              <LootGrid data={options} />
            </>
          );
        })}
      </div>
    </AdLayout>
  );
}
